import { render, staticRenderFns } from "./FeaturedFlightsPopup.vue?vue&type=template&id=531aaac4&"
import script from "./FeaturedFlightsPopup.vue?vue&type=script&lang=js&"
export * from "./FeaturedFlightsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports